import { Container, Divider, Typography, Grid2, useMediaQuery  } from '@mui/material/';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import badnorth from './screenshots/badnorth.png'
import islandstrains from './screenshots/islandstrains.jpg'
import UI from './screenshots/UI.png';
import newsettlement from './screenshots/newsettlement.gif'
import buildroads from './screenshots/buildroads.gif'
import routing from './screenshots/routing.gif';
import defend from './screenshots/defend.gif';
import disaster from './screenshots/disaster.gif';
import { Helmet } from 'react-helmet';

const theme = createTheme({
  palette: {
    primary: {
      main: '#ff9727',
      contrastText: 'white',
    },
  },
});

const Surge = () => {
    const isMob = useMediaQuery('(max-width:1000px)');

    return <ThemeProvider theme={theme}>
        <Helmet>
            <title>More Bread Please - YZee Games</title>
            <meta name="description" content="Your kingdom teeters on the edge of disaster - only your trade routes can save it. More Bread Please is a thoughtful medieval strategy game about designing efficient trade routes to keep chaos at bay and your people fed. Not by conquest, but by connection." />
        </Helmet>
        <Container maxWidth="md">

            <Container sx={{paddingBottom:15, paddingTop:15}}>


            <Divider color='white'/>
            <Grid2 container justifyContent={'center'} alignItems={'center'}>
                <Typography align='center' fontFamily={'Metamorphous'} sx={{fontSize: 55, maxWidth:'md'}} color='white'>More Bread Please!</Typography>
            </Grid2>
            <Divider color='white' sx={{marginBottom: 3}}/>

                <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden' }}>
                    <iframe
                        allowFullScreen
                        title="trailer"
                        style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        border: 'none',
                        }}
                        src="https://www.youtube.com/embed/CRBDjz2Pwnw"
                    ></iframe>
                </div>
        
            <Typography align='center' fontFamily={'Patrick Hand'} sx={{fontSize: 26, marginTop: 3}} color='white'>Your kingdom teeters on the edge of disaster - only your trade routes can save it. More Bread Please is a thoughtful medieval strategy game about designing efficient trade routes to keep chaos at bay and your people fed. Not by conquest, but by connection.</Typography>
            
        </Container>
    </Container>

        <Container sx={{backgroundColor:'white', minWidth:'100%'}}>
            <Container maxWidth="md" sx={{paddingBottom:25, paddingTop:15}}>





            <Grid2 container justifyContent={'center'} alignItems={'center'}>
                <Typography fontFamily={'Metamorphous'} sx={{fontSize:isMob ? 36.5 : 46.5, mb:1}} color='#463c30'>Gameplay Footage</Typography>
            </Grid2>

                <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden' }}>
                    <iframe
                        allowFullScreen
                        title="trailer"
                        style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        border: 'none',
                        }}
                        src="https://www.youtube.com/embed/l82xndA5LE0"
                    ></iframe>
                </div>

    </Container>
    </Container>


<Container sx={{minWidth:'100%', paddingBottom:25, paddingTop:15}}>
        <Container maxWidth="md">
            <Grid2 container direction={'column'} alignItems={'left'}>
                <Grid2 container>
                <Typography fontFamily={'Metamorphous'} sx={{fontSize: 46.5, color:'white'}}>Features</Typography>
                </Grid2>

                <Typography fontFamily={'Metamorphous'} sx={{fontSize: 36.5, color:'white', mt:3}} color='#463c30'>🗺️ Route Based Logistics</Typography>
                <Typography component="ul" fontFamily={'Patrick Hand'} sx={{fontSize: 27.5, color:'white', mb:2}}>
                    <li>Draw trade routes using wagons on land and ships on water</li>
                    <li>Transport essential resources like food, wood, stone, and gold</li>
                    <li>Optimise delivery networks to prevent starvation</li>
                </Typography>
                <img alt={"screenshot1"} src={routing} style={{width:'100%', marginBottom:30}}></img>

                <Typography fontFamily={'Metamorphous'} sx={{fontSize: 36.5, color:'white', mt:3}} color='#463c30'>🛠️ Build & Connect</Typography>
                <Typography component="ul" fontFamily={'Patrick Hand'} sx={{fontSize: 27.5, color:'white', mb:2}}>
                    <li>Construct roads, bridges, and forts</li>
                    <li>Upgrade infrastructure to boost efficiency and defense</li>
                    <li>Every few turns welcome new settlements into your trade network - each offering a key resource</li>
                </Typography>
                <img alt={"screenshot1"} src={newsettlement} style={{width:'100%', marginBottom:20}}></img>
                <img alt={"screenshot1"} src={buildroads} style={{width:'100%', marginBottom:30}}></img>

                <Typography fontFamily={'Metamorphous'} sx={{fontSize: 36.5, color:'white', mt:3}} color='#463c30'>⚔️ Defend Your Network</Typography>
                <Typography component="ul" fontFamily={'Patrick Hand'} sx={{fontSize: 27.5, color:'white', mb:2}}>
                    <li>React to barbarian invasions by positioning battalions and building forts</li>
                    <li>Battle resolution is turn-based and visible, adding strategic tension</li>
                    <li>Protect food routes or risk starvation and loss</li>
                </Typography>
                <img alt={"screenshot1"} src={defend} style={{width:'100%', marginBottom:30}}></img>

                <Typography fontFamily={'Metamorphous'} sx={{fontSize: 36.5, color:'white', mt:3}} color='#463c30'>🌊 Disaster & Environment Adaptation</Typography>
                <Typography component="ul" fontFamily={'Patrick Hand'} sx={{fontSize: 27.5, color:'white', mb:2}}>
                    <li>Survive floods and earthquakes that destroy settlements and break supply lines</li>
                    <li>Reroute and rebuild before your settlements starve</li>
                    <li>Each map presents a new geographic and resource puzzle, challenging you to navigate and adapt to rivers, waterfalls, cliffs, deserts, hills, and mountains</li>
                </Typography>
                <img alt={"screenshot1"} src={disaster} style={{width:'100%', marginBottom:30}}></img>

            </Grid2>
        </Container>
    </Container>





    <Container sx={{minWidth:'100%', paddingBottom:25, paddingTop:15, backgroundColor:'white'}}>
        <Container maxWidth="md">
            <Grid2 container direction={'column'} alignItems={'left'}>
                <Grid2 container>
                <Typography fontFamily={'Metamorphous'} sx={{fontSize: 46.5, color:'#463c30'}}>Art & Aesthetic</Typography>
                </Grid2>

                <Typography component="ul" fontFamily={'Patrick Hand'} sx={{fontSize: 27.5, color:'#463c30', marginTop:3}}>
                    <li>Low-poly 3D art inspired by Bad North and similar looking games</li>
                    <li>Simple textures with stylised models</li>
                    <li>Stylised and readable - clear strategy visuals</li>
                    <li>UI is minimal and readable with an elegant medieval feel</li>
                    <li>Variety in terrain and environment</li>
                </Typography>

                <Typography fontFamily={'Metamorphous'} sx={{fontSize: 27.5, color:'#463c30', marginTop:5}}>Bad North</Typography>
                <img alt={"screenshot1"} src={badnorth} style={{width:'100%'}}></img>

                <Typography fontFamily={'Metamorphous'} sx={{fontSize: 27.5, color:'#463c30', marginTop:3}}>Islands and Trains</Typography>
                <img alt={"screenshot1"} src={islandstrains} style={{width:'100%'}}></img>

                <Typography fontFamily={'Metamorphous'} sx={{fontSize: 27.5, color:'#463c30', marginTop:3}}>UI Design</Typography>
                <img alt={"screenshot1"} src={UI} style={{width:'100%'}}></img>

            </Grid2>
        </Container>
    </Container>




    <Container sx={{minWidth:'100%', paddingBottom:25, paddingTop:15}}>
        <Container maxWidth="md">
            <Grid2 container direction={'column'} alignItems={'left'}>

                            <Grid2 container>
                <Typography fontFamily={'Metamorphous'} sx={{fontSize: 46.5, color:'white'}}>Sound & Atmosphere</Typography>
                </Grid2>

                <Typography component="ul" fontFamily={'Patrick Hand'} sx={{fontSize: 27.5, color:'white', marginTop:3}}>
                    <li>A calm but tense medieval mood: nature sounds, peasant voices, wheels creaking, ambient disasters</li>
                    <li>Medieval themed soundtrack drawing from cultures during the middle ages</li>
                    <li>Sound reinforces gameplay states (danger, scarcity, relief)</li>
                    <li>Needs to evoke togetherness and unity - everything connected</li>
                </Typography>

                <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden', marginTop:30 }}>
                    <iframe
                        allowFullScreen
                        title="trailer"
                        style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        border: 'none',
                        }}
                        src="https://www.youtube.com/embed/GGfttSfGbBM?start=56&autoplay=1&rel=0"
                    ></iframe>
                </div>
                
                                <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden', marginTop:30 }}>
                    <iframe
                        allowFullScreen
                        title="trailer"
                        style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        border: 'none',
                        }}
                        src="https://www.youtube.com/embed/K7ZqZVunCb4?start=147&autoplay=1&rel=0"
                    ></iframe>
                </div>

                                                <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden', marginTop:30 }}>
                    <iframe
                        allowFullScreen
                        title="trailer"
                        style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        border: 'none',
                        }}
                        src="https://www.youtube.com/embed/HVw_1RZncec?start=59&autoplay=1&rel=0"
                    ></iframe>
                </div>


                                <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden', marginTop:30 }}>
                    <iframe
                        allowFullScreen
                        title="trailer"
                        style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        border: 'none',
                        }}
                        src="https://www.youtube.com/embed/OxMQjlBq6zQ?start=6228&autoplay=1&rel=0"
                    ></iframe>
                </div>

            </Grid2>
        </Container>
    </Container>

    
    <Container sx={{minWidth:'100%', paddingBottom:25, paddingTop:15, backgroundColor:'white'}}>
        <Container maxWidth="md">
            <Grid2 container direction={'column'} alignItems={'left'}>
                <Grid2 container>
                <Typography fontFamily={'Metamorphous'} sx={{fontSize: 46.5, color:'#463c30'}}>Progress</Typography>
                </Grid2>

                <Typography component="ul" fontFamily={'Patrick Hand'} sx={{fontSize: 27.5, color:'#463c30'}}>
                    <li>Development started Jan 6, 2024</li>
                    <li>Core systems and gameplay loop are in place</li>
                    <li>Art and audio direction locked in</li>
                    <li>UI is nearly complete</li>
                    <li>Informal playtesting ongoing with friends and family</li>
                </Typography>


                                <Grid2 container>
                <Typography fontFamily={'Metamorphous'} sx={{fontSize: 46.5, color:'#463c30', marginTop:8}}>Diversity & Community Impact</Typography>
                </Grid2>

                <Typography component="ul" fontFamily={'Patrick Hand'} sx={{fontSize: 27.5, color:'#463c30'}}>
                    <li>Collaborating with charity Space2b to upskill migrant and refugee creatives and provide them with opportunities for visibility and professional growth</li>
                    <li>An emphasis on a multicultural team brings varied perspectives to development</li>
                    <li>UI and gameplay designed to be intuitive and inclusive, with features supporting players of all abilities</li>
                    <li>Character customiser supports all genders, skin tones, and cultures allowing everyone to feel represented</li>
                    <li>Fortified structures and soundtrack reflect global influences - not just classic Western medieval styles which is seen so often</li>
                </Typography>
                

                                <Grid2 container>
                <Typography fontFamily={'Metamorphous'} sx={{fontSize: 46.5, color:'#463c30', marginTop:8}}>Funding Goals</Typography>
                </Grid2>

                <Typography component="ul" fontFamily={'Patrick Hand'} sx={{fontSize: 27.5, color:'#463c30', textAlign: 'left'}}>
                    <li>Core Development Completion</li>
                    <li>Diversity Initiatives</li>
                    <li>Accessibility & Localisation</li>
                    <li>QA & Playtesting</li>
                    <li>Steam Release & Publishing</li>
                    <li>Marketing & Outreach</li>
                </Typography>

            </Grid2>
        </Container>
    </Container>


  </ThemeProvider>
}

export default Surge;